<template>
  <div>
    <div class="ms-auto w-md-auto mt-2" v-if="!EmailSent && $store.state.page >= showFromPage">
      <button
        @click="generateClaimIdentifier('igenyazonosito')"
        class="btn btn-red claim-identifier"
        :disabled="emailVerification && !(emailVerification === email)"
      >
        Díjszámítási küldése email-ben
      </button>
    </div>
    <div class="ms-auto w-md-auto mt-2" v-else-if="EmailSent && $store.state.page >= showFromPage">
      <button class="btn btn-red claim-identifier" disabled>
        Email elküldve
      </button>
    </div>
  </div>
</template>
<script>
import {mapFields} from 'vuex-map-fields';

export default {
  props: ['showFromPage'],
  methods: {
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
      console.log('itt a verfy');
      this.$store.dispatch('verifyPage');
      this.$store.commit('setClaimIdentifier', null);
      this.$store.commit('setDMEmailSent', true);
      this.$store.commit('setNavigationBackButton', true);
    },
  },
  computed: {
    ...mapFields([
      'contractSettings.emailVerification',
      'contractSettings.emailVerified',
      'contractSettings.email',
    ]),
    ClamIdentifie() {
      return this.$store.state.code;
    },
    EmailSent() {
      return this.$store.state.dm_email_sent;
    },

    isBackButtonDiabled() {
      return this.$store.state.isBackButtonDisabled;
    },
  },
};
</script>
